import { MediaLibraryState } from '../types'
import { MediaLibraryEssence } from '@/types/mediaLibrary'

const isHasMore =
  (state: MediaLibraryState) =>
  (essence: MediaLibraryEssence): boolean => {
    return state.value.get(essence)?.hasMore ?? false
  }

export default isHasMore
